import React from "react";
import "../styles/Footer.css";
import cccLogo from "../assets/ccc-logo.png";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Brand & About */}
        <div className="footer-brand">
          <img src={cccLogo} alt="Chennai Car Care" className="footer-logo" />
          <p className="footer-desc">
            Premium car detailing, paint protection and care in Chennai. We
            restore, protect and maintain your car with industry-grade products
            and certified technicians.
          </p>
          <div className="footer-social">
            {/* Instagram */}
            <a
              href="https://www.instagram.com/chennaicarcare"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
              className="instagram"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="currentColor"
                width="16"
                height="16"
                focusable="false"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 
                         1.366.062 2.633.334 3.608 1.31.975.976 
                         1.248 2.243 1.31 3.608.058 1.266.07 
                         1.646.07 4.85s-.012 3.584-.07 
                         4.85c-.062 1.366-.335 2.633-1.31 
                         3.608-.975.976-2.242 1.248-3.608 
                         1.31-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.31-.976-.975-1.248-2.242-1.31-3.608C2.175 
                         15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.062-1.365.334-2.632 
                         1.31-3.608.975-.976 2.242-1.248 3.608-1.31C8.416 
                         2.175 8.796 2.163 12 2.163zm0 
                         1.684c-3.17 0-3.548.012-4.795.07-1.037.048-1.602.218-1.975.363-.497.192-.853.423-1.227.797-.374.374-.605.73-.797 
                         1.227-.145.373-.315.938-.363 1.975-.058 
                         1.247-.07 1.625-.07 4.795s.012 3.548.07 
                         4.795c.048 1.037.218 1.602.363 
                         1.975.192.497.423.853.797 
                         1.227.374.374.73.605 1.227.797.373.145.938.315 
                         1.975.363 1.247.058 1.625.07 
                         4.795.07s3.548-.012 4.795-.07c1.037-.048 
                         1.602-.218 1.975-.363.497-.192.853-.423 
                         1.227-.797.374-.374.605-.73.797-1.227.145-.373.315-.938.363-1.975.058-1.247.07-1.625.07-4.795s-.012-3.548-.07-4.795c-.048-1.037-.218-1.602-.363-1.975a3.432 
                         3.432 0 0 0-.797-1.227 3.432 3.432 0 0 
                         0-1.227-.797c-.373-.145-.938-.315-1.975-.363-1.247-.058-1.625-.07-4.795-.07zM12 
                         5.838a6.162 6.162 0 1 0 0 
                         12.324A6.162 6.162 0 0 0 12 
                         5.838zm0 10.162a3.999 3.999 0 1 
                         1 0-7.998 3.999 3.999 0 0 1 0 
                         7.998zm6.406-11.845a1.44 1.44 0 1 
                         1-2.881 0 1.44 1.44 0 0 1 2.881 0z" />
              </svg>
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/chennaicarcare"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
              className="facebook"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="currentColor"
                width="14"
                height="14"
                focusable="false"
              >
                <path d="M22.675 0H1.325C.593 
                         0 0 .593 0 1.325v21.351C0 
                         23.407.593 24 1.325 
                         24h11.495v-9.294H9.691V11.01h3.129V8.414c0-3.1 
                         1.894-4.788 4.659-4.788 1.325 
                         0 2.463.099 2.795.143v3.24l-1.918.001c-1.505 
                         0-1.796.716-1.796 1.765v2.315h3.587l-.467 
                         3.696h-3.12V24h6.116C23.407 
                         24 24 23.407 24 22.675V1.325C24 
                         .593 23.407 0 22.675 0z" />
              </svg>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/919626727777"
              aria-label="Chat on WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 32 32"
                fill="currentColor"
                width="16"
                height="16"
                focusable="false"
              >
                <path d="M16.027 3.001C9.383 3.001 4 
                         8.385 4 15.027c0 2.646.872 
                         5.093 2.338 7.093L4 29l7.073-2.3a11.935 
                         11.935 0 0 0 4.954 1.055c6.643 
                         0 12.027-5.385 12.027-12.028 
                         0-6.642-5.384-12.026-12.027-12.026zm0 
                         21.829c-1.746 0-3.38-.51-4.752-1.389l-.341-.214-4.199 
                         1.364 1.392-4.089-.222-.352a9.078 9.078 
                         0 0 1-1.415-4.909c0-5.022 4.086-9.108 
                         9.107-9.108 5.021 0 9.107 4.086 
                         9.107 9.108s-4.086 9.109-9.107 
                         9.109zm5.007-6.834c-.272-.136-1.609-.795-1.857-.885-.248-.092-.43-.137-.61.136-.181.273-.7.885-.859 
                         1.065-.158.182-.316.205-.588.068-.272-.137-1.148-.424-2.187-1.352-.809-.72-1.356-1.61-1.515-1.882-.158-.273-.017-.421.12-.558.124-.123.273-.317.409-.477.137-.158.182-.273.272-.454.091-.182.045-.341-.022-.478-.068-.136-.609-1.469-.835-2.011-.221-.53-.446-.459-.609-.467l-.518-.01c-.182 
                         0-.478.068-.728.341s-.955.933-.955 
                         2.275c0 1.341.977 2.637 1.113 
                         2.816.137.182 1.926 2.94 4.66 
                         4.123.651.28 1.16.447 
                         1.555.573.653.208 1.248.179 
                         1.717.109.523-.078 1.609-.658 
                         1.835-1.294.226-.637.226-1.182.158-1.293-.068-.113-.249-.182-.521-.318z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/services">Services</a></li>
            <li><a href="/book">Book an Appointment</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-links">
          <h4>Services</h4>
          <ul>
            <li>Ceramic Coating</li>
            <li>PPF (Paint Protection Film)</li>
            <li>OBD Scanning</li>
            <li>Detailing & SPA</li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <div><strong>Phone 1:</strong> +91-9626727777</div>
          <div><strong>Phone 2:</strong> +91-7448876665</div>
          <div><strong>Email:</strong>support@chennaicarcare.in</div>
          <div>
            <strong>Address:</strong> 187/52, Rukmani Nagar, 2nd Street,
            Perumbakkam, Medavakkam, Chennai, Tamil Nadu 600100
          </div>
          <div><strong>Hours:</strong> Tue–Sun, 9:00 AM – 8:00 PM - Mon Holiday</div>
        </div>
      </div>

      {/* Divider + Bottom */}
      <div className="footer-divider"></div>
      <div className="footer-bottom">
        © {year} Chennai Car Care. All rights reserved since 2016.
      </div>
    </footer>
  );
}
